module.exports = __webpack_public_path__ + "a978e0396c357cc64d2700836bf9cf6d.pdf";